import { Container } from '@microfrontends/react-components'
import {
	IntroductionSectionContainer,
	IntroductionSectionWrapper,
	ImageWrapper,
	ObjectPerson,
	Content,
	Decoration
} from './IntroductionSection.css'

const IMAGE_SERVICE = process.env.IMAGE_BASE_URL + '/images/career-path'
export default function IntroductionSection() {
	return (
		<Container>
			<IntroductionSectionContainer>
				<IntroductionSectionWrapper>
					<ImageWrapper>
						{/* eslint-disable @next/next/no-img-element */}
						<img
							src={IMAGE_SERVICE + '/section-wrapper.png'}
							alt='Section wrapper image'
						/>
						<ObjectPerson
							src={IMAGE_SERVICE + '/section-person.png'}
							alt='Section person image'
						/>
						<Decoration />
						<Decoration isHorizontal />
					</ImageWrapper>
					<Content>
						{`Bạn có nhận ra rằng mỗi ngày mình đều quẩn quanh trong mê cung sự nghiệp không lối thoát, tự hỏi vì sao là bước vào rồi lại mù tịt về con đường phía trước như vậy?
					Lạc vào mê cung là do chưa xác định đúng về con đường sự nghiệp, chưa đối chiếu được bản thân hay còn lấn cấn chuyện lộ trình thăng tiến. Còn mãi “vấn vương” trước con đường phát triển sự nghiệp là còn mãi “trật nhịp” cho tương lai phía trước.
					Cùng VietnamWorks thoát khỏi mê cung sự nghiệp bằng cách tham khảo lộ trình thăng tiến của tất cả các ngành nghề, bạn nhé!
          `}
					</Content>
				</IntroductionSectionWrapper>
			</IntroductionSectionContainer>
		</Container>
	)
}
